export default "__VITE_ASSET__DRIkspJL__"